import { Controller } from '@hotwired/stimulus'
import { connectUserData } from '../helpers/controllerHelpers/utils'
import { passesConditions } from '../api/helpers/conditions'

type UserDataValue = Record<string, unknown>

export default class extends Controller {
  static values = {
    conditions: String, //{ type: Array, default: [] },
    // userData: Object, // Implicit from connectUserData
    override: { type: Boolean, default: false },
  }

  declare readonly overrideValue: boolean
  declare readonly conditionsValue: string
  disconnectUserData: (() => void) | undefined
  declare userDataValue: UserDataValue

  connect() {
    this.disconnectUserData = connectUserData(this, this.userDataValueChanged)
  }

  disconnect() {
    if (typeof this.disconnectUserData === 'function') this.disconnectUserData()
  }

  /* This exists to (hopefully) prevent conflict with other components that can also hide themselves outside of conditions */
  overrideValueChanged(newValue?: UserDataValue | boolean, oldValue?: UserDataValue | boolean) {
    if (newValue === oldValue) return
    if (oldValue === undefined) return
    if (newValue === false) this.userDataValueChanged(this.userDataValue)
  }

  userDataValueChanged(userData: UserDataValue, oldUserData?: UserDataValue) {
    if (userData === undefined) return
    /* 
    Prevents an extra call when overrideValue is changed (which usually lines up with userdata changes). 
    Can be removed if things are not working properly.
    */
    if (this.overrideValue === true) return
    /* Re-evaluate condition */
    const rawConditions = decodeURIComponent(this.conditionsValue)
    if (!rawConditions) return
    const conditions = JSON.parse(rawConditions)
    if (!Array.isArray(conditions)) return
    if (userData && oldUserData && conditions.length) {
      const isSameValues = conditions.every(
        (condition) =>
          userData[condition.key] !== undefined &&
          oldUserData[condition.key] !== undefined &&
          userData[condition.key] === oldUserData[condition.key]
      )
      if (isSameValues) return
    }
    const condition = passesConditions(conditions, userData)
    condition ? this.show() : this.hide()
  }

  hide() {
    ;(this.element as HTMLElement).style.display = 'none'
  }
  show() {
    ;(this.element as HTMLElement).style.display = ''
  }
}
